import Button from "app/components/Button";
import rightArrow from "assets/svgs/ic_right_arrow_primary.svg";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import TitleText from "../../components/TitleText";
import { selectIsGoogleLogin, selectLoginForm } from "../../redux/selector";
import GoogleLoginButton from "./GoogleLoginButton";
import LoginForm from "./LoginForm";
import { useLogin } from "./useLogin";


export default function Login() {
  const loginForm = useSelector(selectLoginForm);
  const isGoogleLogin = useSelector(selectIsGoogleLogin);
  const { handleSubmit, isDisabled } = useLogin();

  return (
    <div className="flex flex-col items-center">
      <TitleText title="Welcome back" />
      <form className="flex flex-col gap-[20px] w-full min-w-[390px] mb-[56px]">
        <LoginForm />
        <div className="flex flex-col gap-[10px] items-center">
          <Button
            disabled={isGoogleLogin || isDisabled()}
            onClick={handleSubmit}
            isLoading={loginForm.isLoading}
            className="w-full h-[56px]"
          >
            Log in
          </Button>
          <span className="text-base text-secondary">or</span>
          <GoogleLoginButton />
        </div>
      </form>
      <div className="flex flex-row items-center gap-[16px] w-full  justify-center">
        <p className="text-secondary text-md flex flex-row no-wrap gap-[6px] w-fit">
          Don’t have an account?
          <Link
            to="/auth/signup"
            className="text-primary font-medium flex flex-row whitespace-nowrap gap-[4px] min-w-fit "
          >
           <span>Sign up</span> <img sizes="16px" src={rightArrow} alt="Arrow" />
          </Link>
        </p>
      </div>
    </div>
  );
}
